/* eslint-disable semi */
import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

const sessionKey = process.env.SESSION_KEY;

Vue.use(Vuex);

const debug = process.env.NODE_ENV === 'development';
const plugins = [createPersistedState({ key: sessionKey })];
// const plugins = [createPersistedState({ storage: window.sessionStorage })];

// ----------------------------------------------------------------------------
// Store
// ----------------------------------------------------------------------------
const Store = new Vuex.Store({
  modules: {
    core: {
      namespaced: false,
      state: {
        isLogin: false,
        user: {},
        csrf: null,
        expire: null
      },
      getters: {
        isLogin: state => state.isLogin,
        user: state => state.user,
        csrf: state => state.csrf,
        expire: state => state.expire,
        // 認証情報有効期間チェック
        isExpired: state => {
          if (state.expire === null) {
            return false;
          }
          return (state.expire < (new Date()).getTime());
        }
      },
      mutations: {
        login: (state, user) => {
          state.isLogin = true;
          state.user = user;
          state.expire = (new Date()).getTime() + 10 * 1000;
        },
        logout: state => {
          state.isLogin = false;
          state.user = {};
          state.expire = (new Date()).getTime() - 1;
        },
        setCsrf: (state, csrf) => {
          state.csrf = csrf;
        },
        clearCsrf: (state) => {
          state.csrf = null;
        },
        alive: (state) => {
          // 30分(30*60*1000)延長
          state.expire = (new Date()).getTime() + 1800000;
        }
      },
      actions: {
        login: async ({ commit }, user) => {
          commit('login', user);
        },
        logout: async ({ commit }) => {
          commit('logout');
        },
        setCsrf: async ({ commit }, csrf) => {
          commit('setCsrf', csrf);
        },
        clearCsrf: async ({ commit }) => {
          commit('clearCsrf');
        },
        alive: async ({ commit }) => {
          commit('alive');
        }
      }
    }
  },
  strict: debug,
  plugins: plugins
});

export default function () {
  return Store;
}



// WEBPACK FOOTER //
// ./src/store/index.js